<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Ledger') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/AccountantsSubmenu.vue'

export default {
  name: 'AccountantsLedgerMenu',
  components: { AccountantsSubmenu },
  computed: {
    menuItems() {
      return [
        {
          label: this.$gettext('Cost categories'),
          name: 'Ledger',
          icon: 'fa-table-list',
        },
        {
          label: this.$gettext('Ledger categories'),
          name: 'LedgerCategoriesTable',
          icon: 'fa-layer-group',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
